/**
 * @module app.bdc.list.signOrderCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SignOrderCtrl($scope, $uibModalInstance, order, Notification, clientService, $log) {
        var self = {};
        self.order = order;

        // Sign modal
        self.rdvOrigin = null;
        self.sponsor = {
            corporateName: null,
            name: null,
            firstName: null,
            nim: null,
            email: null,
            emailConfirm: null,
            gift: 'GLADY',
            isLeadsNeodis: false
        };
        self.comment = null;
        self.dateSignature = moment().format('DD/MM/YYYY');
        self.teteReseauMPDV = null;
        self.sponsoring = false;

        self.toggleSponsoring = function() {
            self.sponsoring = !self.sponsoring;
            if(!self.sponsoring){
                self.resetSponsorValues();
            }
        };

        self.sign = function() {
            if(self.sponsoring && !self.sponsor.email || self.sponsor.email !== self.sponsor.emailConfirm){
                Notification.error("Les adresses e-mail ne correspondent pas.");
                return;
            }
            if(self.sponsoring && (!self.sponsor.corporateName || !self.sponsor.name || !self.sponsor.firstName || !self.sponsor.email)){
                Notification.error("Veuillez remplir tous les champs du parrain.");
                return;
            }
            $uibModalInstance.close({
                rdvOrigin: self.rdvOrigin,
                sponsor: self.sponsor,
                comment: self.comment,
                dateSignature: self.dateSignature,
                teteReseauMPDV: self.teteReseauMPDV
            });
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        self.resetSponsorValues = function resetSponsorValues() {
            self.sponsor = {corporateName: null,
                name: null,
                firstName: null,
                nim: null,
                email: null,
                emailConfirm: null,
                gift: 'GLADY'
            };
        };

        self.clients = [];
        self.isSearchLoading = false;
        self.searchedClient = null;
        self.hasBeenSearched = false;

        self.selectedFilter = '';
        self.storeFilters = [
            { state: '', label: 'Tout' },
            { state: 0, label: 'Pré-client' },
            { state: 1, label: 'Client' },
            { state: 2, label: 'Ancien client' },
            { state: 3, label: 'Prospect' },
            { state: 4, label: 'Ancien Propriétaire' },
            { state: 5, label: 'Attente Reprise' }
        ];
        self.selectedNetworkFilter = '';
        self.networkFilters = [
            { state: '', label: 'Tout' },
            { state: '300', label: 'Bimedia' },
            { state: '302', label: 'Devlyx' },
        ]

        /**
         * Search clients according to a research
         */
        self.searchClient = function searchClient() {
            if (!self.searchedClient || self.searchedClient === '') {
                return;
            }
            self.isSearchLoading = true;
            self.hasBeenSearched = true;

            clientService
                .searchClient(self.searchedClient)
                .then(function(clients) {
                    self.clients = clients;
                })
                .catch(function(err) {
                    $log.error(err);
                })
                .finally(function() {
                    self.isSearchLoading = false;
                });
        };

        self.getClient = function (client){
            self.sponsor.corporateName = client.corporateName;
            self.sponsor.name = client.lastName;
            self.sponsor.firstName = client.firstName;
            self.sponsor.nim = client.storeId;
            self.sponsor.email = client.email;
        }

        return self;
    }

    SignOrderCtrl.$inject = ['$scope', '$uibModalInstance', 'order', 'Notification', 'clientService', '$log'];

    angular.module('app.bdc.list.signOrderCtrl', ['ui.bootstrap']).controller('SignOrderCtrl', SignOrderCtrl);
});
